import { useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import programmeDetails from "../utils/programmeDetails.json";
import "../assets/css/newstudent.css";
import { FaRegClock } from "react-icons/fa";
import ApplyForm from "../components/ApplyForm";
import Navbar from "../components/Navbar";

import CollegeOfNursingStaff from "../utils/staff/CollegeOfNursing";
import BiomedicalEngineringStaff from "../utils/staff/BiomedicalEngineering";
import AnaesthetictechnicianStaff from "../utils/staff/AnaestheticTechnician";
import MedicalAndPsychiatrySocialWorkStaff from "../utils/staff/Medicalandpsychiatrysocialwork";
import SchoolOfHealthInformationManagementNDStaff from "../utils/staff/SchoolofHealthInformationManagement";
import SchoolOfHealthInformationManagementHNDStaff from "../utils/staff/SchoolofHealthInformationManagement";
import CommunityHealthStaff from "../utils/staff/CommunityHealth";
import PostbasicNursingStaff from "../utils/staff/postbasicNursing";
import OverviewPanel from "../components/OverviewPanel";
import StaffListPanel from "../components/StaffList";
import logoProgramme from "../assets/images/luth-logo-32x32.png";
import programmeImages from "../utils/programmeDetails";

const resolveImageUrl = (
  val,
  {
    fallback = `${process.env.PUBLIC_URL}/images/default-programme-image.jpg`,
    publicPrefix = "/assets/",
  } = {},
) => {
  if (!val) return fallback;

  if (typeof val === "string") {
    if (val.startsWith("http") || val.startsWith("data:")) return val;
    if (val.startsWith("/")) return val;
    return `${process.env.PUBLIC_URL}/${val}`;
  }

  if (typeof val === "object") {
    if (val.default && typeof val.default === "string") return val.default;
    if (val.src && typeof val.src === "string") return val.src;
  }

  return fallback;
};

const staffImports = {
  "Department of Nursing Sciences": CollegeOfNursingStaff,
  "Department of Nursing Sciences": CollegeOfNursingStaff,
  "Department of Post Basic Nursing": PostbasicNursingStaff,
  "Anaesthetic Technicians": AnaesthetictechnicianStaff,
  "Federal School of Biomedical Engineering": BiomedicalEngineringStaff,
  "Biomedical Engineering (HND)": BiomedicalEngineringStaff,
  "School of Medical and Psychiatry Social Work":
    MedicalAndPsychiatrySocialWorkStaff,
  "School of Health Information Management":
    SchoolOfHealthInformationManagementNDStaff,
  "School of Health Information Management (HND)":
    SchoolOfHealthInformationManagementHNDStaff,
  "School Of Post Basic Nursing": PostbasicNursingStaff,
  "School of Community Health": CommunityHealthStaff,
};

const CLOSED_ITEMS = [
  "School of post basic nursing",
  "School of Community Health",
  "School of Health Information Management (ND)",
  "perioperative nursing",
  "accident & emergency",
  "Anaesthetic Technicians",
  "critical care nursing",
  "paediatric nursing",
  "Ophthalmic Nursing",
  "neonatal nursing",
  "nephrology nursing",
  "dental nursing",
  "Biomedical Engineering (ND)",
  "Department of Nursing Sciences",
  "School of Medical and Psychiatry Social Work",


  // You can also close by programme name here
  // "Post Basic Nursing",
  // "Community Health",
  // "Health Information Management (ND)",
];

const normalize = (s) => (s ? String(s).trim().toLowerCase() : "");

const ProgrammePage = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const { programme, schoolName, applicationSchoolName } = state || {};
  const [activeTab, setActiveTab] = useState("overview");

  const programmeInfo = programmeDetails[programme] || {};
  const StaffList =
    staffImports[schoolName] || staffImports[programmeInfo?.name] || [];

  const alternatives = Object.entries(programmeDetails)
    .filter(([key, val]) => {
      const progSchool = val?.schoolName || val?.school || "";
      return key !== programme && progSchool !== schoolName;
    })
    .map(([key, val]) => ({
      key,
      name: val?.name || key,
      schoolName: val?.schoolName || val?.school || "Other",
    }));

  const isClosedProgrammeOrSchool = () => {
    const closedItems = CLOSED_ITEMS.map(normalize);

    const valuesToCheck = [
      schoolName,
      applicationSchoolName,
      programmeInfo?.name,
      programme,
    ]
      .filter(Boolean)
      .map(normalize);

    return valuesToCheck.some((value) => closedItems.includes(value));
  };

  const importedImage = programmeImages[programme]?.image;
  const programmeImageUrl = resolveImageUrl(importedImage || logoProgramme, {
    fallback: logoProgramme,
  });

  const resolvedProgrammeForApply = programmeInfo.name || programme || "";

  const resolvedSchoolNameForApply = (() => {
    const schoolNorm = normalize(schoolName);
    const appSchoolNorm = normalize(applicationSchoolName);
    const progName = programmeInfo.name || "";

    if (schoolNorm === normalize("Department of Nursing Sciences")) {
      return "Department of Nursing Sciences";
    }

    if (
      schoolNorm === normalize("Federal School of Biomedical Engineering") ||
      schoolNorm === normalize("School of Health Information Management") ||
      appSchoolNorm === normalize("Federal School of Biomedical Engineering") ||
      appSchoolNorm === normalize("School of Health Information Management")
    ) {
      return progName;
    }

    return applicationSchoolName || schoolName || progName;
  })();

  const displayProgrammeTitle = programmeInfo.name || programme || "";
  const displaySchoolTag = resolvedSchoolNameForApply;

  const renderTabContent = () => {
    switch (activeTab) {
      case "overview":
        return <OverviewPanel programmeInfo={programmeInfo} />;

      case "requirements":
        return (
          <ul>
            {(programmeInfo.requirements?.length
              ? programmeInfo.requirements
              : ["No requirements listed."]
            ).map((req, i) => (
              <li key={i}>{req}</li>
            ))}
          </ul>
        );

      case "staff":
        if (!StaffList || !Array.isArray(StaffList) || StaffList.length === 0) {
          return (
            <div>
              <h3>Staff</h3>
              <p>No staff list available for this programme/school.</p>
            </div>
          );
        }

        return (
          <div>
            <StaffListPanel staffList={StaffList} />
          </div>
        );

      case "apply":
        if (isClosedProgrammeOrSchool()) {
          return (
            <div className="apply-closed">
              <h2>Applications Closed</h2>
              <p>
                Applications for{" "}
                <strong>{programmeInfo.name || programme || schoolName}</strong>{" "}
                are currently closed. We apologise for any inconvenience.
              </p>

              <div style={{ marginTop: 16 }}>
                <p>
                  For enquiries, please contact the Schools Administration
                  Office:
                  <br />
                  <a href="mailto:schools@luth.gov.ng">schools@luth.gov.ng</a>
                </p>
              </div>
            </div>
          );
        }

        return (
          <div className="apply-tab">
            <div>
              <h2>Application Instructions</h2>
              <br />
              <h3>
                PLEASE READ THE FOLLOWING INSTRUCTIONS CAREFULLY BEFORE
                REGISTRATION.
              </h3>
              <br />
              <p>
                <strong>
                  PLEASE ENSURE YOU REGISTER WITH YOUR VALID WHATSAPP NUMBER FOR
                  FURTHER NECCESSARY COMMUNICATION
                </strong>
                <br />
                1. Go through your registration and be sure they are correct
                before submission.
                <br />
                2. Applicants are to fill ALL their information in CAPITAL
                LETTERS.
                <br />
                3. Once submitted, no correction can be made except at the main
                portal.
                <br />
                4. Any further correction will attract extra payment.
                <br />
                5. Ensure your passport is affixed correctly.
                <br />
                6. You must bring your coloured Bio-data to the examination
                hall.
                <br />
                7. Awaiting Results is NOT allowed.
                <br />
                8. Payment and filling of form should be done once and for all.
                <br />
                9. Forms not submitted before closure are null and void.
              </p>
            </div>

            <h3>Apply for {resolvedProgrammeForApply}</h3>

            <ApplyForm
              selectedProgramme={resolvedProgrammeForApply}
              schoolName={resolvedSchoolNameForApply}
              fee={programmeInfo.fee}
            />
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <>
      <Navbar />
      <div className="newstudents-wrapper">
        <div className="subschool-title-banner">
          <h1 className="subschool-title">{displayProgrammeTitle}</h1>
          <p className="school-name-tag">{displaySchoolTag}</p>
        </div>

        <div className="programme-layout">
          <div className="programme-main">
            <div className="programme-header">
              <img
                src={programmeImageUrl}
                alt={programmeInfo.name}
                className="programme-image"
              />
              <h1 className="programme-title">{programmeInfo.name}</h1>
            </div>

            <br />

            <div className="programme-tab">
              {["overview", "requirements", "staff", "apply"].map((tab) => (
                <button
                  key={tab}
                  className={`tab-btns ${activeTab === tab ? "active" : ""}`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab.charAt(0).toUpperCase() + tab.slice(1)}
                </button>
              ))}
            </div>

            <div className="tabs-content">{renderTabContent()}</div>
          </div>

          <div className="programme-sidebar">
            <div className="sidebar-card">
              <h3>Application Fee</h3>
              <p className="fee-amount">₦{programmeInfo.fee || "N/A"}</p>
            </div>
            <div className="sidebar-card">
              <h3>Duration</h3>
              <p>
                <FaRegClock style={{ marginRight: 6 }} />
                {programmeInfo.duration || "N/A"}
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProgrammePage;

// To close by **school name**, add the school to `CLOSED_ITEMS`. To close by **programme name**, add the programme name to the same array. Both will work without changing the rest of the page.

// For example:

// ```jsx
// const CLOSED_ITEMS = [
//   "School of Community Health",
//   "Community Health",
// ];
// ```

// That would close the application whether the page receives `"School of Community Health"` as the school or `"Community Health"` as the programme.
